import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import styled from 'styled-components';
import ProjectsContext from './ProjectsContext';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';


const TitleContainer = styled.div`
    height:30px;
    display:flex;
    align-items:center;
    padding-left:10px;
    width:100%;

    width: 220px;
    justify-content: space-between ;
`
const Title = styled.div`
color: rgba(0, 0, 0, 0.87);
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
`;

const ListItemContainer = styled.div`
    padding-left:10px;
`
const context = ProjectsContext; 

class ProjectListSection extends React.Component {

    // constructor(props)
    // {
    //     super(props);
    // }
    
    static contextType = ProjectsContext;
    
    render()
    {
        const {gbu} = this.props;
        let {projects = []} = gbu;
        const {selectProject,selectGbu,reduxStore,aboutCurrentUser,displayFunctionList} = this.context;
        const {selectedProjectOrGbu} = reduxStore;
        const canSelectGbu = aboutCurrentUser.isGbuAdmin || aboutCurrentUser.isAdmin || aboutCurrentUser.isGbuLevelApprover;

        // If there's a selected project and it's not a GBU, only show that specific project
        if (selectedProjectOrGbu && !selectedProjectOrGbu.isGbu) {
            projects = projects.filter(project => project.id === selectedProjectOrGbu.id);
        }

        if (projects.length === 0) return null;

        return(<>
        <ListItem style={{width:'100%'}}
         button={canSelectGbu} 
         selected = {selectedProjectOrGbu && selectedProjectOrGbu.isGbu && selectedProjectOrGbu.id === gbu.id} 
         onClick={canSelectGbu ? ()=> { selectGbu(gbu); displayFunctionList(true) }: null}> 
         {/* onClick={canSelectGbu ? ()=>selectGbu(gbu) : null}>  */}
            <TitleContainer>
                 <Title>{gbu.name}</Title>
                 {/* <IconButton style={{paddingLeft:35}} color="primary" onClick={() => {
                        
                    }
                    }> */}
                    <ArrowForwardIosIcon style={{color:'rgb(61, 122, 150)'}}/>
                {/* </IconButton> */}
                 
                 
            </TitleContainer>
        </ListItem>
        <Divider/>

             {projects.map(project => {
                 let projectNameToDisplay = '';
                 if (project.preferredName) {
                    projectNameToDisplay = project.preferredName && project.preferredName.length >= 17 ? project.preferredName.substring(0, 17) + '...' : project.preferredName;
                 } else {
                    projectNameToDisplay = project.name && project.name.length >= 17 ? project.name.substring(0, 17) + '...' : project.name;
                 }
                 
                 return (<ListItemContainer key={project.id}>
                        <ListItem 
                            divider 
                            button 
                            onClick={() => {
                                selectProject(project);
                                displayFunctionList(true);
                            }}
                            selected={selectedProjectOrGbu && !selectedProjectOrGbu.isGbu && selectedProjectOrGbu.id === project.id} 
                        > 
                     <ListItemText title={project.name} primary={projectNameToDisplay} secondary={project.jobNumber}/>
                    </ListItem>
                    </ListItemContainer>);

             })}
        </>)    
    }
}

export default ProjectListSection;